const ValidatePostCode = postcode => {
       let codePattern = /^[ABCEGHJKLMNPRSTVXY]{1}[0-9]{1}[ABCEGHJKLMNPRSTVWXYZ]{1} ?[0-9]{1}[ABCEGHJKLMNPRSTVWXYZ]{1}[0-9]{1}$/i;
       return codePattern.test(postcode);
};

export {
       ValidatePostCode
};